import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog,  faFile, faFileContract, faImage, faCalendar, faBook, faNewspaper, faGavel, faMusic, faVideo } from '@fortawesome/free-solid-svg-icons';
import { DeleteButton, DownloadButton, EditButton } from "../../components/TableActionButtons";
import api from '../../api';
import { z } from 'zod';


// Utility function to truncate text
const truncateDescription = (text, maxLength = 100) => {
    if (text.length > maxLength) {
        return text.substring(0, maxLength) + '...';
    }
    return text;
};

// Add this helper function before getUploadsTableConfig
const getMediaTypeIcon = (mediaType) => {
    const type = mediaType?.name?.toLowerCase();
    switch (type) {
        case 'video':
            return  faVideo
        case 'audio':
            return faMusic
        case 'image':
            return faImage
        default:
            return faFileContract
    }
};


export const getTimelineTableConfig = (handleEdit, handleDelete) => [
    {
        header: () => (
            <span className="flex items-center">
                {/* <FontAwesomeIcon icon={faFile} className="w-4 h-4 mr-2" /> */}
                EVENT
            </span>
        ),
        accessorKey: 'title',
        cell: ({ row }) => (
            <div className="flex flex-col justify-start items-start truncate">
                <div className="text-left flex flex-col items-start">
                    
                    <div className="flex flex-row items-center">
                    <FontAwesomeIcon icon={getMediaTypeIcon(row.original.media_type)} className="w-4 h-4 mr-2" />
                        <span className="font-medium">{row.original.heading}</span>

                        <span className="text-gray-500 text-sm line-clamp-2 ml-2">{new Date(row.original.date).getFullYear()||'-'}</span>
                        
                    </div>
                  
                </div>
                <div className="text-left mt-1">
                    {row.original.event && (
                        <span className="text-gray-500 text-sm line-clamp-2">
                            {truncateDescription(row.original.event)}
                        </span>
                    )}
                </div>
            </div>
        )
    },


    {
        header: () => (
            <span className="flex items-center justify-center">
                <FontAwesomeIcon icon={faCog} className="w-4 h-4 mr-2" />
                ACTIONS
            </span>
        ),
        id: 'actions',
        cell: ({ row }) => (
            <div className="flex items-center justify-center gap-3">
                <EditButton onClick={() => handleEdit(row.original)} row={row} />
                <DeleteButton onClick={() => handleDelete(row.original)} row={row} />
            </div>
        )
    }
];

export const PAGE_CONFIG = {
    BREADCRUMB: [
        { label: 'Home', link: '/' },
        { label: 'Administration', link: null },
        { label: 'Timeline', link: '/timeline' }
    ],
    PAGE_TITLE: 'Timeline',
    GET_QUERY_KEY: 'timeline',
    SEARCH_DESCRIPTION: 'Search for a timeline by title, description, or material type',
    SEARCH_PLACEHOLDER: 'No timelines found',
    API_CALL: () => api.timeline.getTimeline(),
    DEFAULT_ERROR_MESSAGE: 'Failed to fetch timeline',
    SELECT: (data) => data?.data,
    //Delete
    DELETE_API_CALL: (id) => api.timeline.deleteTimeline(id),
    DELETE_ERROR_MESSAGE: 'Failed to delete timeline',
    DELETE_SUCCESS_MESSAGE: 'Timeline deleted successfully',
    //Create
    CREATE_API_CALL: (data) => api.timeline.createTimeline(data),
    CREATE_ERROR_MESSAGE: 'Failed to create timeline',
    CREATE_SUCCESS_MESSAGE: 'Timeline created successfully',

    //Get Material Types
    GET_MEDIA_TYPES_API_CALL: () => api.mediaTypes.getMediaTypes(),
    GET_MEDIA_TYPES_ERROR_MESSAGE: 'Failed to fetch media types',
    GET_MEDIA_TYPES_SUCCESS_MESSAGE: 'Media types fetched successfully'
};

export const INITIAL_FORM_STATE = {
    heading: '',
    date: '',
    event: '',
    thumbnail: '',
    media_type_id: '',
    manual: '',
    url: ''
    
};
export const INITIAL_FILES_STATE = {
    manual: null,
    thumbnail: null
};

export const INITIAL_FORM_ERRORS = {
    heading: '',
    date: '',
    event: '',
    thumbnail: '',
    media_type_id: '',
    manual: '',
    url: ''
};

export const getFormConfig = (formData, handleInputChange, handleFileChange, errors, isEdit, mediaTypes = []) => [
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Heading',
        id: 'heading',
        placeholder: 'Enter Heading',
        name: 'heading',
        type: 'text',
        required: true,
        value: formData.heading,
        onChange: (e) => handleInputChange('heading', e.target.value),
        error: errors.heading

        // error: touched.firstname ? errors.firstname : ''
    },
    {
        formControl: 'date',
        autoComplete: 'off',
        label: 'Date',
        id: 'date',
        placeholder: 'Select Date',
        name: 'date',
        type: 'text',
        required: true,
        value: formData.date,
        onChange: (e) => handleInputChange('date', e.target.value)
        // onBlur: () => handleBlur('lastname'),
        // error: touched.lastname ? errors.lastname : ''
    },
    {
        formControl: 'select',
        autoComplete: 'off',
        label: 'Type',
        id: 'media_type_id',
        placeholder: 'Select Media Type',
        name: 'media_type_id',
        value: formData.media_type_id,
        options: mediaTypes.map((item) => ({ label: item.name, value: item.id })),
        onChange: handleInputChange
    },
    {
        formControl: 'textarea',
        autoComplete: 'off',
        label: 'Event',
        id: 'event',
        placeholder: 'Enter Event',
        name: 'event',
        type: 'text',
        required: true,
        value: formData.event,
        onChange: (e) => handleInputChange('event', e.target.value)
        // onBlur: () => handleBlur('email'),
    },
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Manual',
        id: 'manual',
        placeholder: 'Upload Manual',
        name: 'manual',
        type: 'file',
        required: false,
        value: formData.manual,
        onChange: (e) => {
            handleFileChange('manual', e.target.files[0]);
            handleInputChange('manual', e.target.value);
        },
        hint: 'Accepted formats: PDF, DOC, DOCX (Max size: 10MB)',
        accept: '.pdf,.doc,.docx',
        error: errors.manual
    },
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Thumbnail',
        id: 'thumbnail',
        placeholder: 'Upload Thumbnail',
        name: 'thumbnail',
        type: 'file',
        required: false,
        value: formData.thumbnail,
        onChange: (e) => {
            handleFileChange('thumbnail', e.target.files[0]);
            handleInputChange('thumbnail', e.target.value);
        },
        hint: 'Accepted formats: JPG, PNG, JPEG (Max size: 2MB)',
        accept: '.jpg,.jpeg,.png',
        error: errors.thumbnail
    },
    {
        formControl: 'input',
        autoComplete: 'off',
        label: 'Url',
        id: 'url',
        placeholder: 'Enter Content Url',
        name: 'url',
        type: 'text',
        required: false,
        value: formData.url,
        onChange: (e) => handleInputChange('url', e.target.value),
        error: errors.url

        // error: touched.firstname ? errors.firstname : ''
    }
];
export const UPLOAD_SCHEMA = z.object({
    heading: z.string().min(3, 'Heading must be at least 3 characters'),
    event: z.string().min(3, 'Event must be at least 3 characters'),
    date: z.coerce.date().or(z.string().min(3, 'Invalid date format')),
  //  media_type_id: z.string().min(1, 'Media type is required'),
    url: z.string()
});

export const FILE_SCHEMA = z.object({
    manual: z.instanceof(File, 'Manual must be a file').optional(),
    thumbnail: z.instanceof(File, 'Thumbnail must be a file').optional()
});
